import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { formatPageTitle } from 'ag-common-svc/public-api';
import { MenuItemsConstants } from 'ag-common-lib/public-api';
import { ConferencesComponent } from './conferences.component';

const registrationsMenuItems = MenuItemsConstants.crm.registrations;

const routes: Routes = [
  {
    path: '',
    component: ConferencesComponent,
    title: formatPageTitle([registrationsMenuItems.registrations, registrationsMenuItems.events]),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [],
  exports: [RouterModule],
})
export class ConferencesRoutingModule {}
